const ALLOWED_ENTITY_SECTIONS = new Set([
    'workspace',
    'users',
    'permissions',
    'fields',
    'value-lists',
    'validations',
    'parameters',
    'widgets',
    'imports',
    'literals',
    'customfunc',
    'crons',
    'forms',
    'apikeys',
    'sandbox',
    'integrations',
]);

const OPAQUE_TOKEN_PATTERN = /^[A-Za-z0-9._+/=-]+$/;

export function sanitizeEntityToGo(value) {
    if (typeof value !== 'string' || !value) {
        return null;
    }

    const normalized = value.trim().toLowerCase();
    return ALLOWED_ENTITY_SECTIONS.has(normalized) ? normalized : null;
}

function parseOpaqueToken(value) {
    if (typeof value !== 'string' || !OPAQUE_TOKEN_PATTERN.test(value)) {
        return null;
    }

    return value;
}

function parseOAuthUrl(value) {
    if (typeof value !== 'string' || !value) {
        return null;
    }

    try {
        const decoded = decodeURIComponent(value);
        const url = new URL(decoded);

        if (url.protocol !== 'http:' && url.protocol !== 'https:') {
            return null;
        }

        return decoded;
    } catch {
        return null;
    }
}

function extractHashParam(hash, name) {
    const queryString = hash.includes('?') ? hash.split('?')[1] : '';
    const fromQuery = new URLSearchParams(queryString).get(name);
    if (fromQuery) return fromQuery;

    // Legacy path-embedded format: #/auth/login/sandbox=TOKEN
    const match = hash.match(new RegExp(`${name}=([^&]+)`));
    return match?.[1] ?? null;
}

export function parseAuthHash(hash) {
    return {
        webToken: parseOpaqueToken(extractHashParam(hash, 'token')),
        sandboxToken: parseOpaqueToken(extractHashParam(hash, 'sandbox')),
        state: parseOpaqueToken(extractHashParam(hash, 'state')),
        oauthUrl: parseOAuthUrl(extractHashParam(hash, 'oauthUrl')),
        entityToGo: sanitizeEntityToGo(extractHashParam(hash, 'entityToGo')),
    };
}
